import { Typography } from 'src/modules/core/components'
import type { CancellationPolicyCoverageProps } from './cancellation-policy-coverage.interface'
import classes from './cancellation-policy-coverage.module.scss'

export function CancellationPolicyCoverage({ typesUsingAccount, totalTypes }: CancellationPolicyCoverageProps) {
  return (
    <div className={classes.coverage} data-testid="cancellation-policy-coverage">
      <Typography variant="body" className={classes.title}>
        Which appointments this covers
      </Typography>
      <ul className={classes.list}>
        <li>Appointments created in Google Calendar</li>
        {totalTypes > 0 && (
          <li data-testid="cancellation-policy-coverage-types">
            Appointment types set to <strong>Use account policy</strong> ({typesUsingAccount} of {totalTypes} types)
          </li>
        )}
      </ul>
      <Typography variant="body" className={classes.note}>
        Clients of Google Calendar appointments only see the policy when they try to cancel or reschedule inside the
        window. We don&apos;t add it to your reminders, so let them know another way, for example in your message
        template or on your website.
      </Typography>
    </div>
  )
}
